export enum ModalWidth {
    SMALL = 600,
    SMALL_WIDE = 800,
    MEDIUM = 1000,
    MEDIUM_WIDE = 1200,
}
